// سال زراعی پیش‌فرض سامانه
export const DEFAULT_CROP_YEAR_ID = 19; // 1405
export const DEFAULT_CROP_YEAR_NAME = "1405";

export const CROP_YEAR_STORAGE_KEY = "crop_year_id";

// اگر سال زراعی در لوکال استوریج نباشد، مقدار پیش‌فرض ذخیره می‌شود
export const ensureCropYearId = (): number => {
  const stored = localStorage.getItem(CROP_YEAR_STORAGE_KEY);
  if (!stored || !Number(stored)) {
    localStorage.setItem(CROP_YEAR_STORAGE_KEY, String(DEFAULT_CROP_YEAR_ID));
    return DEFAULT_CROP_YEAR_ID;
  }
  return Number(stored);
};

export const getCropYearId = (): number => {
  const stored = localStorage.getItem(CROP_YEAR_STORAGE_KEY);
  return Number(stored) || DEFAULT_CROP_YEAR_ID;
};

export const setCropYearId = (id: any) => {
  localStorage.setItem(
    CROP_YEAR_STORAGE_KEY,
    String(Number(id) || DEFAULT_CROP_YEAR_ID)
  );
};
